import { Component, OnInit, Input, NgZone, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { AdminTiketService } from '../../services/admin-tiket.service';
import { PageService } from '../../services/page.service';
import { IPage } from '../../model/page';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import {PagerService} from '../../services/pager.service';
//import {IMyDpOptions} from 'mydatepicker';
import { Observable, of, pipe, throwError } from 'rxjs';
import { mergeMap, map, switchMap, debounceTime, catchError } from 'rxjs/operators';
import { ModalComponent } from '../../shared/modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-page-list',
    templateUrl: './page-list.component.html',
    styleUrls: ['./page-list.component.scss'],
    standalone: false
})

export class PageListComponent implements OnInit {
  pages : any;
  isFilterTrue = true;
  // userValue: IUserValue;
  paging: IPage;
  per_page = 10;
  selected_status: number;
  filter: any = { 'name': '', 'order': 'asc'};
  curr_user_id: any;
  total: number = 0;
  public row_header: any = [];
  public header_index: any;
  public assignee_array: any = [];
  private allItems: any[];
  showloader: boolean;
  pager: any = {};
  pagedItems: any[];
  crumbList: any[];
  center: any = 'HR';

  constructor(
    private pagerS: PagerService,
    private adminSer: AdminTiketService,
    private pageSer: PageService,
    private modalService: NgbModal,
    private ngZone: NgZone,
    private route: ActivatedRoute) {
      this.showloader = true;

      const url = this.route.snapshot.url.join().split(',');
      if (url.length > 1) {
        this.center = url[1];
      } else {
        const tempCenter = sessionStorage.getItem( 'center' );
        if (tempCenter) {
          this.center = tempCenter;
        }
      }
      sessionStorage.setItem( 'center', this.center);
    }

  ngOnInit() {
    this.crumbList = [
      { title: 'Home', url: '/dashboard' },
      { title: 'Admin Menu', url: '/admins/admin-menu' }
    ];
    const userData = localStorage.getItem('UserData');
    this.curr_user_id = JSON.parse(userData);
    this.selected_status = null;

    this.row_header  = [
      {text: 'Order', value: 'Order', 'sort': 'desc'},
      {text: 'Page', value: 'Name', 'sort': null}
    ];
    this.header_index = 0;

    this.tableSort(0);
  }

  findLocalPage( id: number ) {
     for ( var idx = 0; idx < this.pages.length; idx++ ) {
        const obj = this.pages[idx];
        if (obj.ID === id) {
          return obj;
        }
     }
     return null;
  }

  deletePage(id: number) {
    const page = this.findLocalPage( id );
    if (page === null) {
      alert('Unable to find Page');
      return;
    }
    const modalRef = this.modalService.open( ModalComponent );
    modalRef.componentInstance.confirmationStr = '<p><strong>Are you sure you want to delete ' +
    '<span class="text-primary">"' + page.Name + '"</span> record?</strong></p>' +
    '<p>All information associated to this Page record will be permanently deleted.' +
    '<span class="text-danger"> This operation can not be undone.</span>' +
    '</p>';
    modalRef.componentInstance.title = 'Page Record';
    modalRef.result.then((res: any) => {
      this.pageSer.deletePage(id).subscribe((data: any) => {
        this.setPage(1);
      });
    })
    .catch( (res: any) => {
    });

  }

  filterByPage(event) {
    this.showloader = true;
    const id = event.target.value;
    this.filter.companyname = id;
    this.setPage(1);
  }

  setPage(page: number = 1) {
        const that = this;

        this.showloader = true;
        this.pageSer
          .getAllPages( this.center, page, this.per_page, this.row_header[this.header_index], this.filter)
          .subscribe( {
              next(data: any) {
                that.showloader = false;
                that.pages = data.data; // return all data
                that.paging = data.page; // return all the paginationinfo
                that.total = that.paging.total;
                that.pager = that.pagerS.getPager(that.paging.total, page, that.per_page);
          },
          error(msg) {
            that.ngZone.run( () => {
              that.showloader = false;
            });
          }
        });
  }

  tableSort(index) {
    if (this.row_header[index].sort === 'none') {
       return;
    }

    this.showloader = true;
    if (this.header_index === index) {
      (this.row_header[index].sort === 'asc') ? this.row_header[index].sort = 'desc' : this.row_header[index].sort = 'asc';
    } else {
      this.row_header[index].sort = 'asc';
      this.row_header[this.header_index].sort = null;
      this.header_index = index;
    }
    this.setPage(1);
  }

}


